import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useBuilder } from "../../Contexts/BuilderContext";
import { Row, Col, Modal, Layout, Space } from 'antd';
import PageHeader from "../../Components/PageHeader";
import {iconMapping} from "../../Configs/AppsConfig";
import PortfolioImport from "../Portfolio/PortfolioImport";
import GraphicCard from "../../Components/GraphicCard";
import { getBuildersMenuItems } from "./builderMenuConfig";
import BuilderStatesManager from "./BuilderStatesManager";

const BuildersLanding = () => {
    const navigate = useNavigate();
    const { setNewPortfolioBuilderContext } = useBuilder();
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => setIsModalVisible(true);
    const closeModal = () => setIsModalVisible(false);

    const onNewPortfolio = (type) => {
        if (type === 'import from file') {
            // Handle file import
            setIsModalVisible(true);
        } else {
            setNewPortfolioBuilderContext({ type });
            navigate('/builders/portfolio');
        }
    };

    const gridItems = getBuildersMenuItems(onNewPortfolio);

    return (
        <Layout>
            <PageHeader title={'Portfolio Builder'} logoUrl={iconMapping.portfolioBuilder} />
            <Layout.Content>
                <Row align={'top'}>
                    <Col flex={'0 0 260px'}>
                        <Space direction={'vertical'} style={{overflowY: "scroll", maxHeight: '90vh'}}>
                            {gridItems.map((item, index) => (
                                <Col span={24}>
                                    <div style={{margin: '32px'}}>
                                        <GraphicCard
                                            title={item.title}
                                            description={item.description}
                                            imgUrl={item.imgUrl}
                                            onClick={()=>onNewPortfolio(item.title.toLowerCase())}
                                            iconUrl={'https://storage.googleapis.com/finiat-web-static-resources/utility/plus-icon-neumorphic-blue.webp'}
                                        />
                                    </div>
                                </Col>
                            ))}
                        </Space>
                    </Col>
                    <Col flex={'1 1 600px'}>
                        <Row justify={'center'} style={{marginTop: '10%'}}>
                            <Col flex={'0 0 600px'}>
                                <BuilderStatesManager />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Layout.Content>
            <Modal title="Import Portfolio" visible={isModalVisible} onCancel={closeModal} footer={null}>
                <PortfolioImport asModal={true} />
            </Modal>
        </Layout>
    );
};

export default BuildersLanding;
